import React, { useCallback, useEffect, useState } from "react";
import Layout from "@/Components/layout/Layout";
import { Link, useParams } from "react-router-dom";
import { getBusinesss } from "@/utils";

export * from "./AddBusinesses";
export * from "./AllBusinesses";

export const RestaurantsFragment = () => {
  const { type } = useParams();
  const [businesses, setBusinesses] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Single search field state

  // Fetch restaurants with the search query
  const fetchBusinesses = useCallback(async () => {
    try {
      const { data } = await getBusinesss({
        type,
        search: "hh",
        limit: 200,
      });
      setBusinesses(data);
      // console.log("Fetched Business Data:", data); // Uncomment to inspect the data structure
    } catch (error) {
      console.error("Error fetching businesses:", error);
    }
  }, [searchQuery, type]);

  // Trigger fetch on page load
  useEffect(() => {
    fetchBusinesses();
  }, [fetchBusinesses]);

  // Group Businesses  by country and then by state
  const groupByCountryState = () => {
    const groupedData = {};

    businesses.forEach((business) => {
      const { country, state } = business;
      if (!groupedData[country]) {
        groupedData[country] = {};
      }
      if (!groupedData[country][state]) {
        groupedData[country][state] = [];
      }
      groupedData[country][state].push(business);
    });

    return groupedData;
  };

  const groupedBusinesses = groupByCountryState();

  const handleSearch = () => {
    fetchBusinesses(); // Trigger the fetch with the current search query
  };

  return <Layout>hjhk</Layout>;
};
